"use client";

import { useLocale } from "next-intl";
import useTranslations from "@/i18n/useTranslations";
import { formatPromoEndDate } from "@/components/PromoBanner/utils/formatPromoEndDate";

export const DEFAULT_END_DATE_PREFIX = "Offer ends";

type Props = {
  prefix?: string;
  date?: string;
};

/**
 * Resolves the promo end-date chrome prefix. English sentinel / missing values
 * use Common.offerEnds; CMS or caller overrides pass through as-is.
 * When `date` is provided, it is formatted for the active locale.
 */
export default function LocalizedOfferEndsPrefix({ prefix, date }: Props) {
  const t = useTranslations("Common");
  const locale = useLocale();
  const prefixText =
    !prefix || prefix === DEFAULT_END_DATE_PREFIX ? t("offerEnds") : prefix;

  if (!date) {
    return <>{prefixText}</>;
  }

  return (
    <>
      {prefixText} {formatPromoEndDate(date, locale)}
    </>
  );
}
